import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=4f22d8b2&scoped=true&"
import script from "./infoForm.vue?vue&type=script&lang=js&"
export * from "./infoForm.vue?vue&type=script&lang=js&"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=4f22d8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22d8b2",
  null
  
)

export default component.exports